// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".activeTab {\n  background-color: white !important;\n  color: #00a88e !important;\n  border-top: 0;\n  border-left: 0;\n  border-right: 0;\n  border-bottom: 2px #00a88e solid !important;\n  font-weight: 800;\n}", ""]);
// Exports
module.exports = exports;
